import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, y = 30, className = "", testid }) {
  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
